// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"f2a73ceb","453":"56c26c30"}[chunkId] + ".chunk.js";
};